const NAV_OPEN_CLASS = "nav-open";

export function openNav(navId = "navBar"): void {
	const nav = document.getElementById(navId);
	// Do NOT force display via inline styles; it overrides CSS `display:flex` needed for `.scrollable` to scroll.
	nav?.style.removeProperty("display");
	nav?.style.setProperty("transform", "translate(0,0)");
}

export function closeNav(navId = "navBar"): void {
	const nav = document.getElementById(navId);
	nav?.style.removeProperty("display");
	nav?.style.setProperty("transform", "translate(-100vw,0)");
}

export function attachClickHandlerForSearch(element: HTMLElement): void {
	// Prevent the nav drawer click-to-close handler from firing if you click inside the form,
	// but do NOT preventDefault (preventDefault on input clicks can block focus on mobile).
	const form = element.querySelector(
		'form[method="get"]',
	) as HTMLFormElement | null;
	if (!form) return;

	if (form.dataset.searchClickBound === "true") return;
	form.dataset.searchClickBound = "true";

	form.addEventListener("click", (e) => {
		e.stopImmediatePropagation();
		e.stopPropagation();
	});
}

export function trapScrollableNavbar(navBar: HTMLElement): void {
	const scrollTarget =
		(navBar.querySelector(".scrollable") as HTMLElement | null) ?? navBar;

	if (scrollTarget.dataset.scrollTrapApplied === "true") return;
	scrollTarget.dataset.scrollTrapApplied = "true";

	scrollTarget.addEventListener(
		"wheel",
		(e) => {
			const delta = e.deltaY;
			const atTop = scrollTarget.scrollTop === 0;
			const atBottom =
				scrollTarget.scrollHeight -
					scrollTarget.clientHeight -
					scrollTarget.scrollTop <=
				1;
			if ((atTop && delta < 0) || (atBottom && delta > 0)) {
				e.preventDefault();
			}
		},
		{ passive: false },
	);
}
